import { CONSTRUCTION_TEMPLATES } from '../core/presets/construction-templates.js';
import { RESTAURANT_TEMPLATES, GENERAL_TEMPLATES } from '../core/presets/restaurant-templates.js';
import type { DocumentTemplate } from '../core/app-store.js';

// Preset IDs match the ones used in TemplateLibrary preview mode
const PRESET_ID_MAP: Record<string, number> = {
  p1: 0, p2: 1, p3: 2, p4: 3, p5: 4,   // construction
  p6: 0, p7: 2, p8: 1,                   // restaurant (vendor, catering, employee)
  p9: 0, p10: 1,                          // general
};

const PRESET_INDUSTRY_MAP: Record<string, 'construction' | 'restaurant' | 'general'> = {
  p1: 'construction', p2: 'construction', p3: 'construction', p4: 'construction', p5: 'construction',
  p6: 'restaurant', p7: 'restaurant', p8: 'restaurant',
  p9: 'general', p10: 'general',
};

export function getPresetTemplate(id: string): DocumentTemplate | null {
  const industry = PRESET_INDUSTRY_MAP[id];
  if (!industry) return null;

  const list =
    industry === 'construction' ? CONSTRUCTION_TEMPLATES :
    industry === 'restaurant'   ? RESTAURANT_TEMPLATES   :
                                  GENERAL_TEMPLATES;

  const idx = PRESET_ID_MAP[id] ?? 0;
  const preset = list[idx];
  if (!preset) return null;

  return {
    ...preset,
    id,
    createdAt: new Date().toISOString(),
    useCount: 0,
  };
}

export function getPreviewTemplates(industry: string): DocumentTemplate[] {
  const base = { createdAt: new Date().toISOString(), useCount: 0 };

  if (industry === 'construction') {
    return CONSTRUCTION_TEMPLATES.map((t, i) => ({
      ...t,
      ...base,
      id: `p${i + 1}`,
    }));
  }
  if (industry === 'restaurant') {
    return [
      { ...RESTAURANT_TEMPLATES[0]!, ...base, id: 'p6' },
      { ...RESTAURANT_TEMPLATES[2]!, ...base, id: 'p7' },
      { ...RESTAURANT_TEMPLATES[1]!, ...base, id: 'p8' },
    ];
  }
  return [
    { ...GENERAL_TEMPLATES[0]!, ...base, id: 'p9' },
    { ...GENERAL_TEMPLATES[1]!, ...base, id: 'p10' },
  ];
}
